import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'
import "./assets/css/reset.css"
import element from "element-ui"
import 'element-ui/lib/theme-chalk/index.css';
import OmMap from '@/components/omap'
import ImageZoomPlugin from './js/ImageZoomPlugin'

// import {
//   Message
// } from 'element-ui'

import JsonExcel from 'vue-json-excel'
Vue.component('DownloadExcel', JsonExcel)

// 你可以自定义 zoomRate
Vue.use(ImageZoomPlugin, { zoomRate: 1.2 }) 

Vue.config.productionTip = false

Vue.use(element)
// Vue.use(Message)
Vue.use(OmMap)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')